<match-display-wrapper
    class="ip-addr-match-readonly"
    [matchLabel]="matchLabel"
    matchCriteria="{{ matchCriteria }}"
>
    <div class="ip-addr-match-readonly__values">
        <div *ngFor="let address of addressList; trackBy: trackByIndex">
            {{ address }}
        </div>
    </div>
</match-display-wrapper>
